import * as React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'
import { cn, schemaFormatToUnits } from '../../lib/utils'
import { ParagraphText } from '../paragraph-text'

const inputDivVariants = cva(
  'flex h-10 w-full border bg-surface-high px-xs py-xs rounded text-on-surface font-normal border-outline text-sm shaded-placeholder ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: '',
        secondary: 'bg-surface-container border-0 file:bg-surface-container'
      }
    },
    defaultVariants: {
      variant: 'primary'
    }
  }
)

const inputVariants = cva('w-full focus-visible:outline-none', {
  variants: {
    variant: {
      primary: '',
      secondary: 'bg-surface-container text-on-surface-variant text-sm placeholder:text-on-surface-variant'
    }
  },
  defaultVariants: {
    variant: 'primary'
  }
})

type CombinedVariantProps = VariantProps<typeof inputDivVariants> & VariantProps<typeof inputVariants>

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement>, CombinedVariantProps {
  format?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, variant, ...props }, ref) => {
  return (
    <div className={cn(inputDivVariants({ variant }), className)}>
      <input
        type={type}
        placeholder={props.placeholder}
        className={cn(cn(inputVariants({ variant })))}
        ref={ref}
        {...props}
      />
      {props.format ? <ParagraphText weight="medium">{schemaFormatToUnits[props.format]}</ParagraphText> : null}
    </div>
  )
})
Input.displayName = 'Input'

export { Input }
